import React from 'react';
import { Flame } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
export function TimerTopBar() {
  const {
    hh,
    mm,
    ss
  } = useCountdown();
  return <div className="bg-[#0e0500] border-b border-[rgba(192,57,43,.4)] py-2.5 px-5 relative z-11" data-id="element-428">
      <div className="max-w-[1100px] mx-auto flex items-center justify-center gap-6 flex-wrap max-md:gap-3 max-sm:gap-2" data-id="element-429">
        <div className="flex items-center gap-2 text-xs font-semibold text-crema-oscuro tracking-[.03em] max-md:text-[11px]" data-id="element-430">
          <Flame className="w-4 h-4 text-rojo-vivo animate-blink-red" data-id="element-431" />
          <span className="max-sm:hidden" data-id="element-432">
            Precio especial de lanzamiento termina en:
          </span>
        </div>

        <div className="flex items-center gap-1" data-id="element-433">
          <div className="flex items-baseline gap-0.5" data-id="element-434">
            <span className="font-playfair text-[1.35rem] font-black text-dorado-claro min-w-[32px] text-center inline-block leading-none max-sm:text-[1.1rem] max-sm:min-w-[26px]" data-id="element-435">
              {hh}
            </span>
            <span className="text-[10px] text-gris-texto uppercase tracking-[.08em]" data-id="element-436">
              h
            </span>
          </div>
          <span className="text-[1.2rem] text-dorado font-black px-0.5 leading-none" data-id="element-437">
            :
          </span>
          <div className="flex items-baseline gap-0.5" data-id="element-438">
            <span className="font-playfair text-[1.35rem] font-black text-dorado-claro min-w-[32px] text-center inline-block leading-none max-sm:text-[1.1rem] max-sm:min-w-[26px]" data-id="element-439">
              {mm}
            </span>
            <span className="text-[10px] text-gris-texto uppercase tracking-[.08em]" data-id="element-440">
              m
            </span>
          </div>
          <span className="text-[1.2rem] text-dorado font-black px-0.5 leading-none" data-id="element-441">
            :
          </span>
          <div className="flex items-baseline gap-0.5" data-id="element-442">
            <span className="font-playfair text-[1.35rem] font-black text-dorado-claro min-w-[32px] text-center inline-block leading-none max-sm:text-[1.1rem] max-sm:min-w-[26px]" data-id="element-443">
              {ss}
            </span>
            <span className="text-[10px] text-gris-texto uppercase tracking-[.08em]" data-id="element-444">
              s
            </span>
          </div>
        </div>

        <a href="#oferta" className="bg-rojo-vivo text-blanco text-[11px] font-bold tracking-[.06em] uppercase py-[7px] px-[18px] rounded-full no-underline transition-all duration-200 whitespace-nowrap hover:bg-[#e74c3c] hover:-translate-y-[1px] max-md:hidden" data-id="element-445">
          Aprovechar ahora →
        </a>
      </div>
    </div>;
}